import {
    Container,
    Row,
    Col
} from "reactstrap";

import {
    FiAward,
    FiBriefcase,
    FiUsers
} from "react-icons/fi";

import "./CadWhyFeesWorth.css";

function CadWhyFeesWorth() {
    return (
        <section className="why-feesworth">

            <Container>

                {/* Section Header */}

                <div className="why-feesworth-header">

                    <span className="why-feesworth-label">
                        WHY FEESWORTH?
                    </span>

                    <h2>
                        Why Learn From <strong>FeesWorth?</strong>
                    </h2>

                    <p>
                        Learn from experienced professionals with
                        practical industry exposure and a strong focus
                        on real-world CAD Automation & Customization.
                    </p>

                </div>


                {/* =================================
                    10 Years of Teaching
                ================================= */}

                <Row className="why-feesworth-row align-items-center">

                    <Col
                        lg="6"
                        md="6"
                        className="mb-4 mb-md-0"
                    >

                        <div className="why-feesworth-image-wrapper">
                            <div className="why-feesworth-small-image">
                                <img
                                    src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_683/https://feesworth.com/wp-content/uploads/2023/09/19245711_6101073-1024x683.jpg"
                                    alt="FeesWorth CAD Automation Training"
                                    className="why-feesworth-image"
                                />
                            </div>


                            <div className="why-feesworth-image-badge">

                                <FiAward />

                                <span>
                                    10+ Years Experience
                                </span>

                            </div>

                        </div>

                    </Col>


                    <Col
                        lg="6"
                        md="6"
                    >

                        <div className="why-feesworth-content">

                            <div className="why-feesworth-icon">
                                <FiAward />
                            </div>

                            <span className="why-feesworth-number">
                                01
                            </span>

                            <h3>
                                10 Years of Teaching
                            </h3>

                            <p>
                                For the past decade, we have passionately
                                and consistently <strong>specialized in CAD
                                    Automation & Customization</strong> training.
                                Our unwavering commitment to this niche
                                field has allowed us to accumulate a wealth
                                of experience and expertise.
                            </p>

                            <p>
                                Over the years, we have honed our training
                                programs to perfection, ensuring that our
                                students receive the highest quality education
                                in this vital aspect of CAD technology.
                            </p>

                            <p>
                                This extensive experience has enabled us to
                                provide our students with valuable insights
                                and knowledge that are not just theoretical
                                but also practical, setting them on a path
                                to success in a competitive job market.
                            </p>

                        </div>

                    </Col>

                </Row>


                {/* =================================
                    Real Projects
                ================================= */}

                <Row className="why-feesworth-row align-items-center">

                    <Col
                        lg="6"
                        md="6"
                        className="order-2 order-md-1"
                    >

                        <div className="why-feesworth-content">

                            <div className="why-feesworth-icon">
                                <FiBriefcase />
                            </div>

                            <span className="why-feesworth-number">
                                02
                            </span>

                            <h3>
                                We work on real projects for MNC
                            </h3>

                            <p>
                                We take pride in our collaboration with
                                renowned companies such as <strong>Donaldson
                                    in the UAE</strong>, <strong>Honeywell in the
                                        USA</strong>, and <strong>Proclass in the
                                            Netherlands</strong>.
                            </p>

                            <p>
                                Over the years, we have successfully undertaken
                                and delivered cutting-edge <strong>CAD
                                    Automation & Customization projects for these
                                    distinguished clients</strong>.
                            </p>

                            <p>
                                These partnerships stand as a testament to our
                                capabilities and the trust these global
                                organizations have placed in our expertise.
                                Our commitment to innovation and precision
                                ensures that we continue to provide tailored
                                solutions that meet the unique needs of our
                                clients and make a significant impact in their
                                respective industries.
                            </p>

                        </div>

                    </Col>


                    <Col
                        lg="6"
                        md="6"
                        className="order-1 order-md-2"
                    >



                        <div className="why-feesworth-small-image">

                            <img
                                src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_1024/https://feesworth.com/wp-content/uploads/2023/09/2945521_28662-1024x1024.jpg"
                                alt="FeesWorth Project"
                            />

                        </div>




                    </Col>

                </Row>


                {/* =================================
                    Corporate Training
                ================================= */}

                <Row className="why-feesworth-corporate align-items-center">

                    <Col
                        lg="5"
                        md="5"
                    >

                        <div className="why-feesworth-small-image">

                            <img
                                src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_1024/https://feesworth.com/wp-content/uploads/2023/09/7176408_3572685-1024x1024.jpg"
                                alt="FeesWorth CAD Project"
                            />

                        </div>

                    </Col>


                    <Col
                        lg="7"
                        md="7"
                    >

                        <div className="why-feesworth-content">

                            <div className="why-feesworth-icon">
                                <FiUsers />
                            </div>

                            <span className="why-feesworth-number">
                                03
                            </span>

                            <h3>
                                We have delivered many corporate training
                            </h3>

                            <p>
                                We also take pride in our successful track
                                record of delivering comprehensive corporate
                                training in CAD Automation and Customization.
                                <strong> Our tailored programs have been
                                    well-received by esteemed companies like
                                    Molex, Bradken, Mold-Masters, and Valeo.</strong>
                            </p>

                            <p>
                                These collaborations attest to our ability to
                                address the unique needs of leading organizations,
                                providing their teams with the specialized
                                skills and knowledge required to excel in CAD
                                Automation and Customization.
                            </p>

                            <p>
                                This recognition in the corporate world
                                reinforces our commitment to excellence and
                                the valuable impact our training has on both
                                individuals and businesses.
                            </p>

                        </div>

                    </Col>

                </Row>

            </Container>

        </section>
    );
}

export default CadWhyFeesWorth